import { useEffect } from 'react';
import { useMutation } from 'react-query';

import { axios } from '@/library/axios';
import type { BaseResponse } from '@/types';
import { displayError } from '@/utils/functions/displayError';

import type { VerifyOtpRequestBody, VerifyOtpResponse } from './types';

const verifyOtp = (
  payload: VerifyOtpRequestBody
): Promise<BaseResponse<VerifyOtpResponse, VerifyOtpRequestBody>> => {
  return axios<
    VerifyOtpRequestBody,
    BaseResponse<VerifyOtpResponse, VerifyOtpRequestBody>,
    VerifyOtpRequestBody
  >({
    url: '/notifications/verification-of-otp',
    method: 'post',
    data: {
      ...payload,
    },
  });
};

export const useVerifyOtp = () => {
  const { mutateAsync, error, isLoading } = useMutation({
    mutationFn: verifyOtp,
  });

  useEffect(() => {
    displayError(error);
  }, [error]);

  return { verifyOtp: mutateAsync, isLoading };
};
